import React, {useState} from "react"
import { ActivityReportInputPropsType } from "./activityreport.component.type"
import Box from "@amzn/meridian/box"
import Row from "@amzn/meridian/row"
import Column from "@amzn/meridian/column"
import Button from "@amzn/meridian/button"
import Text from "@amzn/meridian/text"
import Loader from "@amzn/meridian/loader"
import DatePicker from "@amzn/meridian/date-picker"
import { RadioButtonInlineFormatUtil } from "src/components/helpers/radio-button.util/radio-button.util"
import { activityReportInputTypeData, searchId } from "src/common/constants/inspections.const"
import { InputFieldUtil } from "src/components/helpers/input-field-util/input-field-util"


export const ActivityReportInputComponent = ({activityReportForm,setActivityReportForm,activityReportMissingFields,setActivityReportMissingFields,isSheetOpen,setIsSheetOpen,handleSubmit} : ActivityReportInputPropsType) => {

    const removeField = (field: string) => {
        setActivityReportMissingFields(prevMissingFields => {
            const newMissingFields = { ...prevMissingFields };
            delete newMissingFields[field];
            return newMissingFields;
        })
    }
    const updateForm = (field: string, value: string | boolean) => {
        setActivityReportForm(prevForm => ({ ...prevForm, [field]: value }));
        removeField(field)
    }
    const [placeholder,setPlaceHolder] = useState<string>("Please enter userId")

    const isValidDate = (day : string) =>{
        //Method to disable the dates which are older than one month
        const today = new Date()
        const previousMonth = new Date(today)
        previousMonth.setDate(today.getDate() - 31)       
        return day<previousMonth.toISOString().split('T')[0] || day>today.toISOString().split('T')[0]
    }

    return(
        <Column alignmentHorizontal="center" spacing="none">
            <Box className="useractivity-input-container" width="50%" type="outline" spacingInset="400">
            <div className="useractivity-search-component">
                <Column spacing="300">
                <Row alignmentHorizontal="center" widths={["grid-6", "grid-1","grid-3"]} spacing="100"  wrap="down">
                    <InputFieldUtil inputFieldData={searchId}
                            value={activityReportForm.searchId}
                            setValue={(value: string) => {
                                updateForm("searchId", value)
                            }}
                            onBlur={() => {}}
                            mask={""}
                            error={activityReportMissingFields.hasOwnProperty("searchId")}
                            errorMessage={activityReportMissingFields["searchId"] ?? undefined}
                            placeholder= {placeholder}
                            size="medium"
                    />
                    
                        <Text type="h100" alignment="right">From</Text>
                        <div>
                            <DatePicker 
                                value={activityReportForm.startDate}
                                onChange={(value: string) => {
                                    updateForm("startDate", value)
                                }}
                                error={activityReportMissingFields.hasOwnProperty("startDate")}
                                width="170px"
                                disabledDates={isValidDate}
                                errorMessage={activityReportMissingFields["startDate"] ?? undefined}/>
                        </div>
                        
                    </Row>
                <Row alignmentHorizontal="center" widths={["grid-6", "grid-1","grid-3"]} spacing="100"  wrap="down" >
                    <RadioButtonInlineFormatUtil radioButtonData={activityReportInputTypeData}
                                customisedStyle={{ display: "grid", gridGap: "16px", gridTemplateColumns: "repeat(3,auto)" }}
                                value={activityReportForm.searchType}
                                setValue={(value: string) => {
                                    updateForm("searchType", value)
                                    setPlaceHolder(`Please enter ${value}`)
                                    removeField("searchId")
                                }}
                    />
                            <Text type="h100" alignment="right">To</Text>
                            <div >
                            <DatePicker 
                                    value={activityReportForm.endDate}
                                    onChange={(value: string) => {
                                        updateForm("endDate", value)
                                    }}
                                    placeholder="YYYY-MM-DD"
                                    error={activityReportMissingFields.hasOwnProperty("endDate")}
                                    width="170px"
                                    disabledDates={isValidDate}
                                    errorMessage={activityReportMissingFields["endDate"] ?? undefined}/>
                                    </div>
                    </Row>
                    </Column>
                    <Row alignmentHorizontal={"center"} spacingInset="300">
                <Button disabled={activityReportForm.isLoading || Object.keys(activityReportMissingFields).length !== 0}
                            size="medium"
                            onClick={() => {
                                if (Object.keys(activityReportMissingFields).length !== 0) return;
                                setActivityReportForm({ ...activityReportForm, showResultsInfo: false, isLoading: true })
                                handleSubmit(activityReportForm, activityReportMissingFields, setActivityReportMissingFields)
                            }}>
                            {activityReportForm.isLoading ?
                                <> Loading <pre /> <Loader type="circular" size="small" /> </> :
                                "Search"
                            }
                        </Button>
                    </Row>
            </div>
        

    </Box>

        </Column>
    
    )

}